import { render, staticRenderFns } from "./batchAllocation.vue?vue&type=template&id=8dd59424&scoped=true&"
import script from "./batchAllocation.vue?vue&type=script&lang=js&"
export * from "./batchAllocation.vue?vue&type=script&lang=js&"
import style0 from "./batchAllocation.vue?vue&type=style&index=0&id=8dd59424&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dd59424",
  null
  
)

export default component.exports